module.exports = __webpack_public_path__ + "img/source-store.43d83b49.png";